module.exports = __webpack_public_path__ + "img/water-pump-3.c4c73649.jpg";